import { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { FunctionalComponent } from 'interfaces/components';
import DownArrowIcon from 'assets/svgs/DownArrowIcon';

interface IDropdownWithArrowProps extends FunctionalComponent {
  label?: string | React.ReactElement;
  logo?: any;
  className?: string;
  dropDownArrowIcon?: React.ReactElement;
  containerClassName?: string;
  menuItemsClassName?: string;
  mobileMenuStyle?: string;
  pointerCursor?: boolean;
  dropDownWidth?: string;
  marginTop?: string;
  spanClassName?: string;
  disabled?: boolean;
  ariaLabel?: string;
}

const DropdownWithArrow: React.FC<IDropdownWithArrowProps> = ({
  children,
  label,
  logo,
  className,
  containerClassName,
  dropDownArrowIcon,
  menuItemsClassName,
  mobileMenuStyle,
  pointerCursor,
  dropDownWidth,
  marginTop,
  spanClassName,
  ariaLabel,
}) => {
  return (
    <Menu
      as="div"
      className={
        mobileMenuStyle
          ? mobileMenuStyle
          : `relative inline-block text-left p-1 pl-2 ${containerClassName}`
      }>
      {/* No focus:outline-hidden: the keyboard focus ring comes from
          globals.css (WHIT-494); it hid where the keyboard was. */}
      <Menu.Button
        type="button"
        aria-label={ariaLabel}
        className={`text-black text-center space-x-1 flex items-center justify-center rounded-full disabled:text-slate-500 ${className}`}>
        <span className={spanClassName}>{logo ? logo : label}</span>
        {dropDownArrowIcon ? (
          dropDownArrowIcon
        ) : (
          <DownArrowIcon
            className={`h-4 w-4 cursor-pointer ${!label && 'ml-auto'}`}
          />
        )}
      </Menu.Button>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95">
        {/* 
          Pass origin-top-left left-0* in menuItemsClassName to open the dropdown from the left side 
          Pass origin-top-right right-0* in menuItemsClassName to open the dropdown from the right side 
        */}
        <Menu.Items
          unmount
          className={`absolute ${marginTop || 'mt-1'} ${
            dropDownWidth ? dropDownWidth : 'w-56'
          } rounded-xl shadow-lg bg-white ring-1 ring-black/5 focus:none focus:outline-hidden ${menuItemsClassName} ${
            pointerCursor ? 'cursor-pointer' : ''
          }`}>
          {children}
        </Menu.Items>
      </Transition>
    </Menu>
  );
};

export default DropdownWithArrow;
